import React from "react";
import { toast } from "react-toastify";

// Klargo Design System toast — the ds-styled notification shared by the
// signup flow and account setup. `position` defaults to react-toastify's
// own default (top-right); pass "bottom-right" for the welcome notification
// the reference LoginDialog shows after signup, which react-toastify renders
// in its own corner even though the app's single ToastContainer defaults to
// top-right for every other toast.
export const dsToast = (kind, { title, text }, options = {}) => toast[kind](
  <div><strong>{title}</strong><div>{text}</div></div>,
  {
    autoClose: 5000,
    icon: false,
    hideProgressBar: true,
    style: {
      fontFamily: '"IBM Plex Sans", system-ui, sans-serif',
      fontSize: 14,
      color: kind === "error" ? "#8f2018" : "#14242e",
      background: kind === "error" ? "#f8e9e7" : "#ffffff",
      border: "1px solid rgba(20,36,46,.16)",
      borderRadius: 12,
      boxShadow: "0 1px 3px rgba(16,30,40,.06)",
    },
    ...options,
  }
);
